import React from 'react';
import { css } from 'emotion';
import { fadeInDown } from '@vromo/ui/styles/animated';
import FontAwesome from '@vromo/ui/components/FontAwesome';
import theme from '@vromo/ui/components/theme';
import Logo from '@vromo/icons/logo';
import { Link } from 'react-router-dom';

export default function Unsuccessful() {
    return (
        <>
            <div style={{ flex: 1 }}>
                <div
                    className={css`
                        width: 100vw;
                        height: 100vh;
                        display: flex;
                        flex-direction: column;
                        justify-content: space-around;
                        padding: 20px;
                    `}
                    style={{ textAlign: 'center' }}>
                    <div
                        className={css`
                            animation: ${fadeInDown} 1.2s ease-in;
                        `}>
                        <FontAwesome
                            icon="times-hexagon"
                            weight="duotone"
                            x7
                            style={{ color: theme.danger }}
                        />
                        <h1 style={{ fontSize: '3em', fontWeight: 300, wordWrap: 'normal' }}>
                            Unsuccessful
                        </h1>

                        <div>
                            <p style={{ fontSize: 15 }}>
                                The last action was unsuccessful. Please visit the{' '}
                                <Link to="/">login screen</Link> and try again.
                            </p>
                        </div>
                    </div>
                    <Logo style={{ height: 35, marginBottom: 8 }} />
                </div>
            </div>
        </>
    );
}
